// Import necessary dependencies
import React, { createContext, useContext, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import apiClient from "../api/apiClient";
import { flushPendingCartItems } from "../utils/pendingCart";

// Create the context
const LocationContext = createContext();

// Provider component
export const Indexpagedata = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);
  const [profiledata, setprofiledata] = useState([]);
  const [nestedSubCategories, setNestedSubcatgegories] = useState([]);
  const [categories, setcategories] = useState([]);

  const [Loading, setLoading] = useState(false);

  const { token, userType, isLoggedIn, userid } = useSelector(
    (state) => state.auth
  );
  const fetchDataprofile = async (id) => {
    if (!userid && !id) return;
    const result = id
      ? await apiClient.get(`/register/${id}/`)
      : await apiClient.get(`/register/${userid}/`);
    if (result.ok) {
      setprofiledata(result.data);
    }
  };

  const fetchSubSubcategories = async () => {
    try {
      const subsubcategoriesRes = await apiClient.get("/subsubcategories/");
      if (!subsubcategoriesRes.ok)
        throw new Error("Failed to fetch subsubcategories");
      setNestedSubcatgegories(subsubcategoriesRes?.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const fetchcategories = async () => {
    try {
      const result = await apiClient.get("/categories/GetAll/");
      if (result.ok) setcategories(result?.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const fetchcart = async () => {
    if (!isLoggedIn) return;
    setLoading(true);

    const result = await apiClient.get("/cartitems/");
    setLoading(false);

    if (result.ok) {
      setCartItems(result.data?.results || []);

      // Ensure checkedItems is updated correctly
      setCheckedItems(
        result.data?.results?.map((item) => {
          return {
            product_id: item?.product_details?.id,
            modelType: item?.product_details?.listings ? "bundle" : "listing",
          };
        }) || []
      );
    }
  };
  // Fetch data on component mount
  useEffect(() => {
    fetchDataprofile();
    const syncCart = async () => {
      if (!userid) return;
      await flushPendingCartItems();
      await fetchcart();
    };
    syncCart();
  }, [userid]);

  useEffect(() => {
    fetchSubSubcategories();
    fetchcategories();
  }, []);

  // Provide data through context
  return (
    <LocationContext.Provider
      value={{
        profiledata,
        fetchDataprofile,
        cartItems,
        setprofiledata,
        Loading,
        checkedItems,
        setCheckedItems,
        fetchcart,
        nestedSubCategories,
        categories,
        setcategories
      }}
    >
      {children}
    </LocationContext.Provider>
  );
};

// Custom hook to consume the context
export const useIndexPageData = () => {
  return useContext(LocationContext);
};
